export default __webpack_public_path__ + "static/media/img5.1aa9c34f.jpeg";